import __request__ from "routing/request";
export function quotaStatus(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.aiservice/ai/quota", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
